import { render, staticRenderFns } from "./ProductPrice.vue?vue&type=template&id=15c49c41&scoped=true"
import script from "./ProductPrice.vue?vue&type=script&lang=ts"
export * from "./ProductPrice.vue?vue&type=script&lang=ts"
import style0 from "./ProductPrice.vue?vue&type=style&index=0&id=15c49c41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c49c41",
  null
  
)

export default component.exports